import { createSelector } from 'reselect';
import { initialState } from './reducer';

const selectForms = state => state.get('forms', initialState);

const makeSelectPrintFrom = () =>
  createSelector(selectForms, formState => ({
    offer: formState.get('offer'),
    monthly_rate: formState.get('monthly_rate'),
    name: formState.get('name'),
    category: formState.get('category'),
    accessories: formState.get('accessories'),
    colors: formState.get('colors'),
  }));

const makeSelectCustomerCode = () =>
  createSelector(selectForms, formState => formState.get('customerCode'));

const makeSelectCustomer = () =>
  createSelector(selectForms, formState => formState.get('customer'));

const makeSelectSearchingCustomer = () =>
  createSelector(selectForms, formState => formState.get('search'));

export {
  selectForms,
  makeSelectPrintFrom,
  makeSelectCustomerCode,
  makeSelectSearchingCustomer,
  makeSelectCustomer,
};
